import { Box, Flex, FormControl } from '@chakra-ui/react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import * as React from 'react';
import { components } from 'react-select';
import DateRangePicker from '~/components/DateRangePicker';
import FormLabel from '~/components/FormLabel/FormLabel';
import Select from '~/components/Select';
import Toggle from '~/components/Toggle';

import { RecentContentFiltersBarTagSelect } from './components';
import { datePickerControllerProps, datePickerProps } from './utils';

const propTypes = {
  sortByValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onSortByChange: PropTypes.func.isRequired,
  sortingOptions: PropTypes.array,
  adFilterValue: PropTypes.bool,
  onAdFilterChange: PropTypes.func,
  tagsValue: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onDatesChange: PropTypes.func.isRequired,
};
/* eslint-disable react/prop-types */
const SingleValue = ({ data, ...props }) => {
  const { label } = data;

  return (
    <components.SingleValue
      {...props}
    >{`Sort by ${label}`}</components.SingleValue>
  );
};
/* eslint-enable react/prop-types */

const DesktopModalFiltersBar = ({
  sortByValue,
  onSortByChange,
  sortingOptions,
  adFilterValue,
  onAdFilterChange,
  tagsValue,
  onTagsChange,
  startDate,
  endDate,
  onDatesChange,
}) => {
  const handleToggle = () => {
    onAdFilterChange(!adFilterValue);
  };

  return (
    <Box
      width="100%"
      paddingY={2}
      paddingX={5}
      backgroundColor={{ base: 'transparent', md: 'gray.50' }}
      borderBottomColor="gray.200"
      borderBottomWidth="1px"
    >
      <Flex justifyContent="space-between">
        <Box display="flex" alignItems="center" flexBasis="33%">
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onDatesChange={onDatesChange}
            controllerProps={{
              ...datePickerControllerProps,
              // so current month is on right
              initialVisibleMonth: () => dayjs().subtract(1, 'month'),
            }}
            // these are all spread into the button
            fontSize="sm"
            paddingX={2}
            paddingY={2}
            height="auto"
            marginRight={2}
            calendarIconProps={{
              mr: 0,
              ml: 2,
              size: 4,
            }}
            {...datePickerProps}
          />
        </Box>

        {onAdFilterChange && (
          <Box display="flex" alignItems="center" flexBasis="33%">
            <FormControl
              alignItems="center"
              display="flex"
              justifyContent="center"
              width="auto"
            >
              <Toggle
                id="ad-toggle-desktop"
                marginRight={2}
                onChange={handleToggle}
                isChecked={adFilterValue}
              />
              <FormLabel
                fontSize="sm"
                color="gray.800"
                htmlFor="ad-toggle-desktop"
                verticalAlign="baseline"
                marginBottom={0}
                paddingBottom={0}
              >
                Includes #ad
              </FormLabel>
            </FormControl>
          </Box>
        )}
        <Box display="flex" alignItems="center" flexBasis="33%">
          <Box width={159}>
            <Select
              aria-label="Set order"
              options={sortingOptions}
              value={sortByValue}
              onChange={onSortByChange}
              components={{ SingleValue }}
              isSearchable={false}
              size="sm"
            />
          </Box>
        </Box>
      </Flex>
      {onTagsChange && (
        <RecentContentFiltersBarTagSelect
          tags={tagsValue}
          onChange={onTagsChange}
          marginTop
        />
      )}
    </Box>
  );
};

DesktopModalFiltersBar.propTypes = propTypes;

export default DesktopModalFiltersBar;
